import React from 'react';
import { Outlet } from 'react-router-dom';
import { ProtectedRoute } from '../routes/ProtectedRoute';
import { LayoutProvider } from '../contexts/LayoutContext';
import MainLayout from './MainLayout';

export default function ProtectedLayout() {
  return (
    <ProtectedRoute>
      <LayoutProvider>
        <MainLayout>
          <Outlet />
        </MainLayout>
      </LayoutProvider>
    </ProtectedRoute>
  );
}
